import { Mark } from 'tiptap'
import { toggleMark } from 'prosemirror-commands'

export default class HighlightMarkWhite extends Mark {
    get name () {
        return 'highlight_mark_white'
    }

    get schema () {
        return {
            attrs: {
                color: {
                    default: 'white',
                }
            },
            parseDOM: [
                {
                    style: 'color',
                    getAttrs (value) {
                        return { color: value }
                    }
                }
            ],
            toDOM (mark) {
                let { color } = mark.attrs
                return ['span', { style: `color: ${color}` }, 0]
            }
        };
    }

    commands ({ type }) {
        return attrs => toggleMark(type, attrs)
    }
}
